module.exports = __webpack_public_path__ + "static/media/accepted.52c0422b.gif";